/**
 * PanelUserCollection
 *
 * @author Simpli CLI generator
 */

import {PageCollection, HttpExclude, RequestExpose} from 'simpli-web-sdk'
import {PanelUser} from '@/model/resource/PanelUser'
import {InternationalRequest} from '@/helpers/InternationalRequest'

/* TODO: review generated class */
@HttpExclude()
export class PanelUserCollection extends PageCollection<PanelUser> {
  constructor() {
    super(PanelUser)
  }
  @RequestExpose() idAddressFk: number[] = []
  @RequestExpose() idUserTypeFk: number[] = []
  @RequestExpose() startDueDate: string | null = null
  @RequestExpose() endDueDate: string | null = null
  @RequestExpose() startCreationDate: string | null = null
  @RequestExpose() endCreationDate: string | null = null
  @RequestExpose() createdByAdm: boolean | null = null

  queryAsPage() {
    return this.listPanelUser()
  }

  async listPanelUser() {
    return await InternationalRequest.get(`/admin/panel-user`, {
      params: this.params,
    })
      .name('listPanelUser')
      .as(this)
      .getResponse()
  }

  async listCsvPanelUser() {
    return await InternationalRequest.get(`/admin/panel-user/export`, {
      params: this.params,
    })
      .name('listPanelUser')
      .as(this)
      .getResponse()
  }
}
